"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const List_1 = __importDefault(require("@material-ui/core/List"));
const ListItem_1 = __importDefault(require("@material-ui/core/ListItem"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const styles_1 = require("@material-ui/core/styles");
const Assignment_1 = __importDefault(require("@material-ui/icons/Assignment"));
const useStyles = styles_1.makeStyles(theme => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
}));
const ListaDocumentos = ({ itens }) => {
    const classes = useStyles();
    return (react_1.default.createElement("div", { className: classes.root },
        react_1.default.createElement(List_1.default, { component: "nav", "aria-label": "main mailbox folders" }, itens.map(({ titulo, onClick }) => (react_1.default.createElement(ListItem_1.default, { key: titulo, button: true, onClick: onClick },
            react_1.default.createElement(ListItemIcon_1.default, null,
                react_1.default.createElement(Assignment_1.default, null)),
            react_1.default.createElement(ListItemText_1.default, { primary: titulo })))))));
};
exports.default = ListaDocumentos;
//# sourceMappingURL=index.js.map